import { notifications } from './notifications.js';

var userMenu = {
  options: {
    // global options
  },

  selectors: {
    user_menu: ".js-user-menu",
    button: ".js-user-menu-button",
  },

  init: function () {
    const self = this;

    self.loadFunctionInside();
  },

  loadFunctionInside: function () {
    const self = this;

    //clicks events
    self.clickEventToggleMenu();
  },

  clickEventToggleMenu: function () {
    const self = this;

    jQuery(self.selectors.button).on("click", function (event) {
      event.preventDefault();
      jQuery(self.selectors.user_menu).toggleClass("header__user-logged--open");
      notifications.closeNotifications();
    });
  },

  closeMenu: function () {
    const self = this;
    jQuery(self.selectors.user_menu).removeClass("header__user-logged--open");
  },
}

// Export
export { userMenu };